import { delay } from './helper'
import { ANGLE_LANDSCAPE, MODE } from './const'
import TWEEN from '@tweenjs/tween.js'

export default class Menu {
	private readonly el: HTMLDivElement
	private readonly labels: HTMLElement[]
	private readonly items: HTMLElement[]
	private readonly logo: HTMLElement
	private readonly inner: HTMLElement
	private readonly isLandscape: boolean
	private readonly mode: 'landscape' | 'portrait'
	private readonly transform: { x?: number; scale?: number; opacity?: number }
	private isOpen = false
	private tween: any

	constructor(el, mode) {
		this.el = el
		this.items = Array.from(this.el.querySelectorAll('.js-menu-item'))
		this.labels = Array.from(this.el.querySelectorAll('.js-menu-label'))
		this.logo = this.el.querySelector('.js-oym-logo')
		this.inner = this.el.querySelector('.js-menu-inner')
		this.mode = mode
		this.isLandscape = mode === MODE.LANDSCAPE
		this.isOpen = false
		this.tween = null
		this.transform = this.isLandscape
			? {
					x: 100
			  }
			: {
					scale: 0.95,
					opacity: 0
			  }

		const btn = this.el.querySelector('.js-menu-btn')
		btn.addEventListener('click', this.onClick.bind(this))
	}

	onClick(event) {
		event.preventDefault()
		this.el.classList.toggle('is-open')
		this.isOpen ? this.close() : this.open()
	}

	open() {
		this.isOpen = true
		if (this.tween) this.tween.stop()

		this.tween = this.isLandscape
			? new TWEEN.Tween(this.transform)
					.to({ x: 0 }, 850)
					.easing(TWEEN.Easing.Exponential.Out)
					.onUpdate(({ x }) => {
						this.transform.x = x
						this.inner.style.transform = `translateX(${x}%) skewX(${ANGLE_LANDSCAPE * -1}deg)`
					})
					.start()
			: new TWEEN.Tween(this.transform)
					.to({ scale: 1, opacity: 1 }, 500)
					.easing(TWEEN.Easing.Exponential.Out)
					.onUpdate(({ scale, opacity }) => {
						this.transform.scale = scale
						this.transform.opacity = opacity
						this.inner.style.transform = `scale(${scale})`
						this.inner.style.opacity = `${opacity}`
					})
					.start()
	}

	close() {
		this.isOpen = false

		if (this.tween) this.tween.stop()

		this.tween = this.isLandscape
			? new TWEEN.Tween(this.transform)
					.to({ x: 100 }, 350)
					.easing(TWEEN.Easing.Cubic.In)
					.onUpdate(({ x }) => {
						this.transform.x = x
						this.inner.style.transform = `translateX(${x}%) skewX(${ANGLE_LANDSCAPE * -1}deg)`
					})
					.start()
			: new TWEEN.Tween(this.transform)
					.to({ scale: 0.95, opacity: 0 }, 250)
					.easing(TWEEN.Easing.Exponential.Out)
					.onUpdate(({ scale, opacity }) => {
						this.transform.scale = scale
						this.transform.opacity = opacity
						this.inner.style.opacity = `${opacity}`
					})
					.start()
	}

	async update(hash) {
		this.hide()
		await delay(250)
		this.items.forEach((item) =>
			item.dataset.slug === hash ? item.classList.add('is-active') : item.classList.remove('is-active')
		)
		this.labels.forEach((label) => (label.style.display = label.dataset.slug === hash ? 'block' : 'none'))
	}

	hide() {
		this.el.classList.remove('is-open')
		this.el.classList.remove('is-visible')
		this.close()
	}

	show(isMenuInverted, isLogoInverted) {
		isLogoInverted ? this.logo.classList.add('is-inverted') : this.logo.classList.remove('is-inverted')
		isMenuInverted ? this.el.classList.add('is-inverted') : this.el.classList.remove('is-inverted')
		this.el.classList.add('is-visible')
	}
}
